import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDotm4VaV3kr1Eg4HBPzeM9fztxkuE1m_0",
  authDomain: "poms-academy.firebaseapp.com",
  projectId: "poms-academy",
  storageBucket: "poms-academy.appspot.com",
  messagingSenderId: "250115485903",
  appId: "1:250115485903:web:835180d3cc44a4e3d347ba",
  measurementId: "G-02TH70ZBMN",
};

export const app = initializeApp(firebaseConfig);
/* 
firebase
  .firestore()
  .enablePersistence()
  .then(() => {
    console.log("Persistence enabled");
  })
  .catch((err) => {
    console.log(err.code);
  }); 
export const projectStorage = firebase.storage();
export const projectFirestore = firebase.firestore();
export const firestoreInit = firebase.firestore;
export const projectAuth = firebase.auth();
*/
